import { styled } from 'styled-components';
import { VerificationCode } from '@idaho-aeyc/ui-kit';

export const SVerificationCode = styled(VerificationCode)``;
